<template>
    <div class="article">
        <div class="articleDetail">
            <p class="title">{{artDetail.title}}</p>
            <p>
               <!-- <span class="time" v-if="pageType === 'inform' && artDetail.publishedTime && artDetail.publishedTime.indexOf('T')>-1 ">发文时间：{{artDetail.publishedTime.split('T')[0]}}</span> -->
                <span class="time" v-if="pageType === 'inform' && artDetail.infoDate && (typeof( artDetail.infoDate)) !== 'string' ">发文时间：{{artDetail.infoDate.slice(0,3).join('-') }}</span>
                <!-- <span class="time" v-if="pageType === 'inform' && artDetail.gmtInsert">发文时间：{{artDetail.gmtInsert.slice(0,3).join('-') }}</span> -->

                <span class="time" v-if="pageType === 'information' &&  artDetail.publishTime && (typeof( artDetail.publishTime)) === 'string'">
                  发布时间：{{artDetail.publishTime ? artDetail.publishTime.split('T')[0] : null }}
                </span>
                 <span class="time" v-if="pageType === 'information' &&  artDetail.publishTime && (typeof( artDetail.publishTime)) !== 'string'">
                  发布时间：{{artDetail.publishTime ? artDetail.publishTime.slice(0,3).join('-') : null }}
                </span>

                <span class="time" v-if="pageType === 'policy'&& artDetail.infoDate ">
                  发文时间：{{artDetail.infoDate ? artDetail.infoDate.split(' ')[0] : null}}
                </span>

                <span class="time" v-if="pageType === 'development' && artDetail.gmtInsert">
                  发文时间：{{ artDetail.gmtInsert ? artDetail.gmtInsert.slice(0,3).join('-') : null}}
                </span>

                <span class="from" v-if="pageType === 'inform' ">{{artDetail.infoEntity || ''}}</span>
                <span class="from" v-if="pageType === 'information' ">{{artDetail.res || ''}}</span>
                <!-- <span class="from" v-if="pageType === 'policy' ">{{artDetail.policyDepartment || ''}}</span> -->

                <span class="code" v-if="pageType === 'inform' ">{{artDetail.infoCode || ''}}</span>
                <span class="code" v-if="pageType === 'information' ">{{artDetail.author || ''}}</span>
                <span class="code" v-if="pageType === 'policy' ">{{artDetail.fileCode || ''}}</span>

                <span class="reader">
                    <img src="@/assets/home/contentReader.png" alt="">阅读
                    <span v-if="pageType === 'inform' ">{{inforeaderCount[artDetail.id] || 0}}</span>
                    <span v-if="pageType === 'information' ">{{informationreaderCount[artDetail.id] || 0}}</span>
                    <span v-if="pageType === 'policy' ">{{policyreaderCount[artDetail.id] || 0}}</span>
                    <span v-if="pageType === 'development' ">{{developmentreaderCount[artDetail.id] || 0}}</span>
                </span>
            </p>

            <p class="content" v-if="pageType === 'inform' " v-html="artDetail.details"></p>
            <p class="content" v-if="pageType === 'information' || pageType === 'policy'  " v-html="artDetail.detail"></p>
            <p class="content" v-if="pageType === 'development' " v-html="artDetail.detail"></p>

            <el-divider v-if="pageType === 'inform' && artDetail.attachment && artDetail.attachment != '' "></el-divider>
        </div>
        <p v-if="pageType === 'inform' && artDetail.attachment && artDetail.attachment != '' " class="adjunct">
            <span><i class="el-icon-paperclip"></i> 附件：</span>
            <el-link v-for="(item,index) in artDetail.attachment"
              :key="index"
              :href="item"
              target="_blank"
              style="display:inline-block; margin-right: 30px;">
              {{artDetail.attachment.length == 1 &&item.indexOf("_")!=-1 ?item.substring(item.indexOf("_")+1):artDetail.attachment.length == 1 &&item.indexOf("_")==-1 ?item.substring(item.lastIndexOf("/")+1):item.split('/').slice(-1).join('').split('_').slice(-1).join('')}}
              <!-- {{item.indexOf('/') === -1 ? item.split('_').slice(-1).join('').split('_').slice(-1).join('') : item.split('/').slice(-1).join('').split('_').slice(-1).join('')}} -->
              <!-- {{item.indexOf('/') === -1 ? item.split('_').slice(-1).join('').split('_').slice(-1).join('') : item.split('/').slice(-1).join('').split('_').slice(-1).join('')}} -->
            </el-link>
        </p>
    </div>
</template>

<script>
export default {
  name: 'articleDetail',
  props: {
    artDetail: Object,
    pageType: String
  },
  components: {

  },
  data () {
    return {
      inforeaderCount: '',
      informationreaderCount: '',
      policyreaderCount: '',
      developmentreaderCount: ''
    }
  },
  computed: {

  },
  created () {
    if (this.pageType === 'inform') { this.informReader() }
    if (this.pageType === 'information') { this.informationReader() }
    if (this.pageType === 'policy') { this.policyReader() }
    if (this.pageType === 'development') { this.developmentReader() }
    // console.log('打印---')
    // console.log(this.pageType)
    // console.log(this.artDetail.attachment,'============')

  },
  mounted () {
    if (this.pageType === 'inform') { this.getinfoRederNum() }
    if (this.pageType === 'information') { this.getinformationRederNum() }
    if (this.pageType === 'policy') { this.getpolicyRederNum() }
    if (this.pageType === 'development') { this.getdevelopmentRederNum() }
    // this.getinfoRederNum()
    // this.getinformationRederNum()
    // this.getpolicyRederNum()
    // this.getdevelopmentRederNum()
  },
  methods: {
    // 通知阅读量统计
    async informReader () {
      try {
        const res = await this.$get(this.$url.inform.informReaderData, {
          // id: this.artDetail.id
          id: this.$route.query.id
        })

        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取通知阅读量
    async getinfoRederNum () {
      try {
        const res = await this.$get(this.$url.serve.readerNum, {
          type: '通知'
        })
        const { code, msg, data } = res.data
        console.log(res.data,'this.inforeaderCount')
        if (code === 200) {
          this.inforeaderCount = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 资讯阅读量统计
    async informationReader () {
      try {
        const res = await this.$get(this.$url.inform.informationReaderData, {
          // id: this.artDetail.id
          id: this.$route.query.id
        })

        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取资讯阅读量
    async getinformationRederNum () {
      try {
        const res = await this.$get(this.$url.serve.readerNum, {
          type: '资讯'
        })
        const { code, msg, data } = res.data
        if (code === 200) {
          this.informationreaderCount = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 政策阅读量统计
    async policyReader () {
      try {
        const res = await this.$get(this.$url.inform.policynReaderData, {
          // id: this.artDetail.id
          id: this.$route.query.id
        })

        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取政策阅读量
    async getpolicyRederNum () {
      try {
        const res = await this.$get(this.$url.serve.readerNum, {
          type: '政策'
        })
        const { code, msg, data } = res.data
        if (code === 200) {
          this.policyreaderCount = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 发展历程统计
    async developmentReader () {
      try {
        const res = await this.$get(this.$url.inform.courseReaderData, {
          // id: this.artDetail.id
          id: this.$route.query.id
        })

        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取发展历程阅读量
    async getdevelopmentRederNum () {
      try {
        const res = await this.$get(this.$url.serve.readerNum, {
          type: '发展历程'
        })
        const { code, msg, data } = res.data
        if (code === 200) {
          this.developmentreaderCount = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.articleDetail{
    padding: 10px 65px 0;
    display: flex;
    flex-flow: column;
    align-items: center;
}
.title{
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #252728;
    text-align: center;
}
.time,
.from,
.code,
.reader{
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8F9096;
    // margin: 24px 16px 57px;
    img{
        width: 11px;
        height: 7px;
        vertical-align: middle;
        margin-right: 3px;
    }
}
.time,
.reader{
  margin: 24px 20px 57px;
}

.from{
  margin: 24px 8px 57px;
}
.content{
    // color: #8F9096;
    color: #000;
    font-size: 16px;
    line-height: 22px;
}
.Con-img{
    margin-top: 25px;
    border-radius: 10px;
    img{
        width: 100%;
        //height: 354px;
        height: auto;
        border-radius: 10px;
        margin-bottom: 60px;
    }
}
.adjunct{
    padding-left: 70px;
    font-size: 16px;
    padding-bottom: 50px;
    .file{
        color: #3056D9;
        text-decoration: underline;
    }
}
</style>
